<template>
  <div class="transform-child-component-main">
      <div class="pbc-component-type-header">
        <div class="pbc-component-type-icon-parent">
          <dice5 :size='16' class="pbc-component-type-icon" />
        </div>
        <div class="pbc-component-type-name">random</div>
      </div>
      <div class="transform-child-component-summary">
        <div class="transform-child-component-text">Random</div>

        <display-or-edit v-model='transform.vars.weight' type='number' label="weight" :variables='variables' />

      </div>

  </div>

</template>
<script>
import DisplayOrEdit from '@ui/atoms/DisplayOrEdit.vue';
import Dice5 from '@icons/Dice5.vue';
import GameVariables from '@edit/tree/gamevariables.js';
export default {
  props:{
    transform:{
      type:Object,
      required:true
    },
    parentTransform:{
      type:Object,
      required:true
    },
    transformsAndSource: {
      type:Object,
      required:true
    }
  },
  data() {
    const gamevariables = new GameVariables(this.transformsAndSource.gamedata);
    const variables = gamevariables.getVariablesForTransform(this.transformsAndSource, this.transform);
    if (typeof(this.transform.vars.weight) !== 'number') {
      const weight = parseFloat(this.transform.vars.weight);
      this.$set(this.transform.vars, 'weight', isNaN(weight) ? 1 : weight);
    }
    return {
      value:10,
      variables
    }
  },
  components:{
    DisplayOrEdit,
    Dice5
  }
}
</script>
